var Handlebars = require('handlebars');
var i18n = require('l10n');
var Cards_Template = require('text-loader!../../js/templates/partial_templates/dashboard_cards.template.htm');
var Venue_Cards_Template = require('text-loader!../../js/templates/partial_templates/dashboard_venues_cards.template.htm');
var Queue_Cards_Template = require('text-loader!../../js/templates/partial_templates/dashboard_queues_cards.template.html');
var TicketRowPartialTemplate = require('text-loader!../../js/templates/partial_templates/ticketRow.partial.template.html');
var LoginRowPartialTemplate = require('text-loader!../../js/templates/partial_templates/loginRow.partial.template.html');
var AppointmentRowPartialTemplate = require('text-loader!../../js/templates/partial_templates/appointmentRow.partial.template.html');
var ProgressPartialTemplate = require('text-loader!../../js/templates/partial_templates/progress.partial.template.html');
var PoweredByPartialTemplate = require('text-loader!../../js/templates/partial_templates/poweredBy.partial.template.html');
var AdPartialTemplate = require('text-loader!../../js/templates/partial_templates/ad.partial.template.html');

Handlebars.registerPartial('cardsTemplate', Cards_Template);
Handlebars.registerPartial('venueCardsTemplate', Venue_Cards_Template);
Handlebars.registerPartial('queueCardsTemplate', Queue_Cards_Template);
Handlebars.registerPartial('ticketRowPartial', TicketRowPartialTemplate);
Handlebars.registerPartial('loginRowPartial', LoginRowPartialTemplate);
Handlebars.registerPartial('appointmentRowPartial', AppointmentRowPartialTemplate);
Handlebars.registerPartial('progressPartial', ProgressPartialTemplate);
Handlebars.registerPartial('poweredByPartialTemplate', PoweredByPartialTemplate);
Handlebars.registerPartial('adPartialTemplate', AdPartialTemplate);


// Issue Ticket Page
var TicketInfoPartialTemplate = require('text-loader!../../js/templates/issueTicket/partials/ticketInfo.partial.template.html');
Handlebars.registerPartial('ticketInfoPartialTemplate', TicketInfoPartialTemplate);

function replaceAccents(str) {
    var replacements = {
        'Ά' : 'Α',
        'Ί' : 'Ι',
        'Ύ' : 'Υ',
        'Ή' : 'Η',
        'Ό' : 'Ο',
        'Ώ' : 'Ω',
        'Έ' : 'Ε',
        'Ϊ' : 'Ι',
        'Ϋ' : 'Υ'
    };

    $.each(replacements, function(key, value) {
        str = str.replace(new RegExp(key, 'g'), value);
    });

    return str;
}


Handlebars.registerHelper('getIndexPlusOne', function(index, options) {
	return index + 1;
});

Handlebars.registerHelper('getAA', function(index, page, options) {
	page = page * 10;
	index ++;
	return page + index;
});


Handlebars.registerHelper('getIndexPlusTwo', function(index, options) {
	if( index == 0)
	{
	return  options.fn(this);
	}

	return options.inverse(this);
});

Handlebars.registerHelper('htmlInjections', function(index, options) {
	return new Handlebars.SafeString(""+index + 12);
});

Handlebars.registerHelper('getBadgeViaFlowStatus', function(flowStatus, options) {
	var flowStatusBadges = {
	    "Normal": "badge-success",
	    "Traffic": "badge-warning",
	    "Full": "badge-danger"
	};

	return new Handlebars.SafeString(flowStatusBadges[flowStatus]);
});

Handlebars.registerHelper('getFlowStatusTranslation', function(flowStatus, options) {
	var flowStatusBadges = {
	    "Normal": i18n.t("queue.flow_normal"),
	    "Traffic": i18n.t("queue.flow_traffic"),
	    "Full": i18n.t("queue.flow_full")
	};

	return new Handlebars.SafeString(flowStatusBadges[flowStatus]);
});

Handlebars.registerHelper('if_eq', function(a, b, options) {

    if(a == b) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});
Handlebars.registerHelper('if_neq', function(a, b, options) {

    if(a != b) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('isSelected', function(a, b, options) {
    //console.info(a +" == "+ b);
    if(a == b) // Or === depending on your needs
        return "selected";
});

Handlebars.registerHelper('getLength', function(text,  options) {
    if(text)
        return text.length;
    else
        return 0;
});

Handlebars.registerHelper('getCharacterLeft', function(text, maxLength,  options) {
    if(text)
        return maxLength - text.length;
    else
        return maxLength;
});

Handlebars.registerHelper('ifAllowToUseIt', function(userLevel, maxLevel, options) {
    //console.info(userLevel +" > "+ maxLevel);
    if(userLevel <= maxLevel) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('allowItToSpecificLevel', function(userLevel, allowLevelCommaSeparated, options) {
    var allowedLevels = allowLevelCommaSeparated.split(",");
    var canAllowThisLevel = false;
    for(var i = 0; i < allowedLevels.length; i++)
    {
        //console.info(allowedLevels[i]);
        if(userLevel == allowedLevels[i])
        {
            canAllowThisLevel = true;
            break;
        }
    }

    if(canAllowThisLevel)
        return options.fn(this);
    else
        return options.inverse(this);
});


Handlebars.registerHelper('ifIsNotNull', function(value, options) {
    //console.info("/"+value+"/");
    if(value) // Or === depending on your needs
        return options.fn(this);
    else
        return options.inverse(this);
});

Handlebars.registerHelper('defaultValueInCaseOfNull', function(value, text, options) {
    if(value) // Or === depending on your needs
        return value;
    else
        return text;
});

Handlebars.registerHelper('defaultValueInCaseOfNullWithTranslation', function(key, value, defaultText, options) {
    if(value) // Or === depending on your needs
        return i18n.t(key + "." + value);
    else
        return i18n.t(key + "." + defaultText);
});


Handlebars.registerHelper('getFullNameOrUsername', function(name, lastname, username, options) {
    return new Handlebars.SafeString(
        (name != null && name != "")
        ? (lastname != null && lastname != "")
            ? lastname + " " + name
            : name
        : (lastname != null && lastname != "")
             ? lastname
             : username
    );
});

Handlebars.registerHelper('round', function(value, toFixed, options) {
    return value.toFixed(toFixed);
});

Handlebars.registerHelper('flowStatusColor', function(value, options) {
    if(value == 'Normal')
        return "color-green";
    else if(value == 'Traffic')
        return "color-orange";
    else
        return "color-red";
});
Handlebars.registerHelper('statusColor', function(value, options) {
    if(value == 'Open')
        return "color-green";
    else
        return "color-red";
});
Handlebars.registerHelper('perCent', function(value1, value2 ,options) {

    var total = value1 + value2;
    total = total == 0 ? 1 : total;
    var perCentValue  = value1/total * 100;
    return parseInt(perCentValue +"");
});

Handlebars.registerHelper('getPieData', function(served, pending, options) {
    var total = served + pending;
    total = total == 0 ? 1 : total;
    return (served/total *360) + "deg";
});

Handlebars.registerHelper('print', function(value1,options) {
    console.log(value1);
});

Handlebars.registerHelper('getMonitorGridId', function(index, collectionLength, options) {
    collectionLength+=""; //convert it to String, so it can be passed as an INDEX to the `gridLines` Object
    // to datas to pairnoume apo global_style_medias.css -> #monitor3.container
	var gridLines = {
	    "3": ["v", "t", "a"],
	    "4": ["c", "v", "t", "a"],
	    "5": ["c", "v", "t", "a", "p"]
	};
	return new Handlebars.SafeString(gridLines[collectionLength][index]);
});

//Sample usage: span {{t "my.key" }}
Handlebars.registerHelper('t', function (i18n_key, options) {
    var result;
    let count;
    if (options.hash.count) {
        count = parseInt(options.hash.count);
    } else if (options.hash.hasOwnProperty('count')) {
        count = 0;
    }
    if (options.hash) {
        options.hash.count = count;
        result = i18n.t(i18n_key, options.hash);
    } else {
        result = i18n.t(i18n_key);
    }

    return result;
});

//replaces accents from greek upper case characters
Handlebars.registerHelper('tu', function (i18n_key, options) {
    var result;
    let count;
    if (options.hash.count) {
        count = parseInt(options.hash.count);
    } else if (options.hash.hasOwnProperty('count')) {
        count = 0;
    }
    if (options.hash) {
        options.hash.count = count;
        result = i18n.t(i18n_key, options.hash);
    } else {
        result = i18n.t(i18n_key);
    }
    return replaceAccents(result.toUpperCase());
});

Handlebars.registerHelper('tc', function (key, count, options) {

    return i18n.t(key, {count: count});
});

Handlebars.registerHelper('open_close_counter', function (counter_status, options) {
    var result;
    if (counter_status == "Open") {
        result = "badge-success";
    } else {
        result = "badge-danger";
    }

    return result;
});

Handlebars.registerHelper('display', function (imagePath, options) {
    var result;
    if (imagePath == null) {
        result = "block";
    } else{
        result = "none";
    }

    return result;
});
Handlebars.registerHelper('not_display', function (imagePath, options) {
    var result;
    if (imagePath != null) {
        result = "block";
    } else{
        result = "none";
    }

    return result;
});

Handlebars.registerHelper('card_clear', function (index, options) {
    var result = index%3==0 ? "both" : "none";
    return result;
});

Handlebars.registerHelper('getFormattedRemainingMinutes', function (minutes, options) {
    return (minutes && (minutes+"").length == 1
        ? "0" + minutes + ":00"
        : minutes && (minutes+"").length == 2
            ? minutes + ":00"
            : minutes && (minutes+"").length > 2
                ? getHoursAndMinutesFor(minutes) + ":00"
                : "00:00"
    );
});

Handlebars.registerHelper('getTime', function (dateInMillis, options) {
    // format the date
    // add leading zeroes to single-digit hours/minutes
    let date = new Date(dateInMillis);
    let d = [
        '0' + date.getHours(),
        '0' + date.getMinutes()
    ].map(it => it.slice(-2)); // take last 2 digits of every component

    // join the components into date
    return d.join(':');
});

Handlebars.registerHelper('getDateTime', function (dateInMillis, options) {
    // format the date
    // add leading zeroes to single-digit day/month/hours/minutes
    let date = new Date(dateInMillis);
    let d = [
        '0' + (date.getMonth() + 1),
        '0' + date.getDate(),
        '0' + date.getHours(),
        '0' + date.getMinutes()
    ].map(it => it.slice(-2)); // take last 2 digits of every component

    // join the components into date
    return date.getFullYear() + '-' + d.slice(0, 2).join('-') + ' ' + d.slice(2).join(':');
});

Handlebars.registerHelper('getQueueNameForLang', function (queueData, options) {
    var lang = i18n.lng();
    if(lang == "en")
        return queueData.englishName;
    return queueData.name;
});

Handlebars.registerHelper('calcMaxNumberOfPeople', function(area, numberOfSquareDistancePerPerson, options) {
    if(!area || !numberOfSquareDistancePerPerson)
        return i18n.t("venue.noLimitOfPeople");

    if(area < 1 || numberOfSquareDistancePerPerson < 1)
        return i18n.t("venue.noLimitOfPeople");

    return Math.floor(area / numberOfSquareDistancePerPerson);
});

Handlebars.registerHelper('isSelectedOption', function(optionId, selectedId, options) {
    if(optionId && optionId == selectedId)
        return "selected='selected'";

    return "";
});

Handlebars.registerHelper('ifEmptyCollection', function(collection, options) {
    if(!collection || collection.length == 0)
        return options.inverse(this);
    else
        return options.fn(this);
});


Handlebars.registerHelper('getTranslationByName', function(name, options) {
    if(!name)
        return "-";

    return new Handlebars.SafeString( i18n.t(`settings.names.${name}`) );

});

Handlebars.registerHelper('getNotifyConfigForTicketIssueStatus', function(status, options) {
    if(!status)
        return {};

    var config = {
        "position": "bottom center",
        "className": "success"
    };

    var text = "";

    switch(status) {
        case "Success":
            config.className = "success";
            text = i18n.t(`ticketsPage.issueStatus.${status}`);
            break;

        case "FailCustomerAlreadyHasTicket":
        case "FailCustomerTicketLimitReached":
        case "FailQueueFull":
        case "FailQueueTicketLimitReached":
        case "FailCustomersInVenueLimitReached":
        case "FailClosedQueue":
            config.className = "info";
            text = i18n.t(`ticketsPage.issueStatus.${status}`);
            break;

        case "FailNoSuchQueue":
        case "FailCustomerNotExists":
            config.className = "error";
            text = i18n.t(`ticketsPage.issueStatus.${status}`);
        case "Fail":
        default:
            config.className = "error";
            text = i18n.t(`ticketsPage.issueStatus.Fail`);
            break;
    }

    return {
        "config": config,
        "text": text
    }
});


function getHoursAndMinutesFor(minutes) {
    var hours = minutes/60;
    var remainingMinutes = minutes%60;

    return (hours && (hours+"").length == 1
        ? "0" + hours + ":00"
        : hours && (hours+"").length == 2
            ? hours + ":00"
            : hours + ((remainingMinutes+"").length == 1
                ? "0" + remainingMinutes + ":00" : remainingMinutes + ":00")
    );
}